module.exports = __webpack_public_path__ + "static/media/jingzhengduishou62.9f064627.jpg";